/* eslint-disable no-console */

const isProduction = !window.config.appDebug;

export const log = (message, ...args) =>
{
  if (!isProduction) console.log(message, args);
};

export const error = (err, ...args) =>
{
  if (!isProduction) console.error(err, args);
};

export default { log, error };
